import React, { useEffect } from 'react';
import { Image, Result } from 'components/shared/AntComponent';
import Logo from 'assets/img/TVS-TS---Logo.png';
import ExamSubmitImg from 'assets/img/exam-submit-2.png';
import SuccessImg from 'assets/img/circle-green.svg';
import kosoftNew from 'assets/img/kosoftnewlogo.png';
import { useSelector } from 'react-redux';

const TestSuccessPage: React.FC = () => {
        const tenantId = useSelector((state: any) => state.tenant.tenantId);

    const disableBackButton = () => {
        window.history.pushState(null, '', window.location.href);
        window.onpopstate = () => {
            window.history.go(1);
        };
    };
    localStorage.removeItem('guestInfoData');
    localStorage.removeItem('sectionInfoData');
    localStorage.removeItem('sectionData');
    localStorage.removeItem('selectedOptions');
    localStorage.removeItem('markReview');
    localStorage.removeItem("timeLeft");
    useEffect(() => {
        disableBackButton();
        return () => {
            window.onpopstate = null; // Cleanup to avoid memory leaks
        };
    }, []);
    return (
        <div className="test-success bg-guest ">
            <div className="text-start ps-3 mb-3 pt-3">
                <Image src={tenantId === 1153 ? kosoftNew : Logo} alt="logo" width="auto" height="62px" preview={false} />
            </div>
            <div className="text-center h-100 my-auto d-flex align-items-center justify-content-center">

                <div className="row mx-0 ps-0 bg-white shadow-sm container align-items-center justify-content-center">
                    <div className="col ps-0 ">
                        <Image src={ExamSubmitImg} alt="exam-submit" width="auto" height="auto" preview={false} />
                    </div>
                    <div className="col-md-5 pe-5">
                        <div className="text-center me-4">
                            <Image src={SuccessImg} height={100} className="text-center" preview={false} />
                            <h3 className="text-success text- fw-bold">Submission Successful</h3>
                            <h5 className="w- mx-auto mt-3 text-gray line-height">Thank you for completing your exam.<br />
                                Your responses have been recorded and submitted for evaluation.
                            </h5>
                        </div>
                        <h6>
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestSuccessPage;
